import { createReducer } from '@reduxjs/toolkit';
import type { IamPasswordValidationError } from '../../enum';
import {
    cancelPasswordResetFailure,
    cancelPasswordResetSuccess,
    checkOtpFailure,
    checkOtpSuccess,
    checkPasswordPolicyFailure,
    checkPasswordPolicySuccess,
    identifyUser,
    identifyUserFailure,
    identifyUserSuccess,
    resetPasswordFailure,
    resetPasswordSuccess,
} from './iam-api-actions';

interface IIamApiState {
    isIdentifyUserSent: boolean;
    isOtpValid: boolean;
    invalidPasswordError?: IamPasswordValidationError;
    isNewPasswordSaved: boolean;
    isPasswordResetCancelled: boolean;
}
export type { IIamApiState };

export const initialState: IIamApiState = {
    isIdentifyUserSent: false,
    isOtpValid: false,
    isNewPasswordSaved: false,
    isPasswordResetCancelled: false,
};

export const iamApiReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(identifyUser, (state) => {
            state.isIdentifyUserSent = false;
        })
        .addCase(identifyUserSuccess, (state) => {
            state.isIdentifyUserSent = true;
        })
        .addCase(identifyUserFailure, (state) => {
            state.isIdentifyUserSent = false;
        })
        .addCase(checkOtpSuccess, (state) => {
            state.isOtpValid = true;
        })
        .addCase(checkOtpFailure, (state) => {
            state.isOtpValid = false;
        })
        .addCase(checkPasswordPolicySuccess, (state) => {
            state.invalidPasswordError = undefined;
        })
        .addCase(checkPasswordPolicyFailure, (state, { payload: invalidPasswordError }) => {
            state.invalidPasswordError = invalidPasswordError;
        })
        .addCase(resetPasswordSuccess, (state) => {
            state.isNewPasswordSaved = true;
        })
        .addCase(resetPasswordFailure, (state) => {
            state.isNewPasswordSaved = false;
        })
        .addCase(cancelPasswordResetSuccess, (state) => {
            state.isPasswordResetCancelled = true;
        })
        .addCase(cancelPasswordResetFailure, (state) => {
            state.isPasswordResetCancelled = false;
        });
});
